import { StudentMaster } from './StudentMaster.model';
import { FranchiseCourseMaster } from './FranchiseCourseMaster.model';
import { ReceiptMaster } from './ReceiptMaster.model';
import { StudentLectureMaster } from './StudentLectureMaster.model';
import { User } from './User.model';
import { CourseMaster } from './CourseMaster.model';
import { PredefinedMaster } from './PredefinedMaster.model';
import { ContentMaster } from './ContentMaster.model';

export class EnrollCourseMaster{
    public enrollCourseMasterId:number;
    public studentMaster:StudentMaster;
    public studentName:String;
    public franchiseCourseMaster:FranchiseCourseMaster;
    public name:String;
    public contactNo:String;
    public email:String;
    public receiptMasterList:ReceiptMaster[];
    public studentLectureMasterList:StudentLectureMaster[];
    public amount:number;
    public pageNumber :number;
    public pageSize:number;
    public createdBy:User;
    public courseMasterTemp:CourseMaster;
    public isDeactive:string;
    public dob:Date;
    public lastStudentLectureMaster:StudentLectureMaster;
    public nextStudentLectureMaster:StudentLectureMaster;
    public predefinedMaster:PredefinedMaster;
    public receiptMasterTemp:ReceiptMaster;
    public studentDob:Date;
    public studentSurname:String;
    public religion:String;
    public caste:String;
    public dateTemp:Date;
    public courseStatus:PredefinedMaster;
    public completedPercent:number;
    public examResultFilePath:string;
  
    public subCaste:String;
    public schoolAddress:String;
    public motherTongue:String
    public gender:PredefinedMaster;
    public genderId:number;
    public address:String;
    public fathersName:String;
    public fathersContactNo:String;
    public fathersOccupation:String;
    public fathersEmailId:String;
    public fathersQualification:String;
    public fathersAadharNo:String;
    public officeNameAndAddress:String;
    public mothersName:String;
    public mothersContactNo:String;
    public mothersOccupation:String;
    public mothersEmailId:String
    public mothersQualification:String;
    public mothersAadharNo:String;
    public guardiansNameAndContactNo:String;
    public description:String;
    public errorMessage:String;
    public defaultStudentLectureMaster:StudentLectureMaster;
    public isRegistrationDone:boolean;
    public registrationDone:string;
    public studentProfileImage:ContentMaster;
    public studentProfileImageId:number;
    public fatherProfileImage:ContentMaster;
    public fatherProfileImageId:number;
    public motherProfileImage:ContentMaster;
    public motherProfileImageId:number;

}